import { Create, SimpleForm, TopToolbar, useNotify, useRedirect } from "react-admin";
import { CircularProgress, useMediaQuery } from "@mui/material";

import { useState } from "react";

import CreateForm from "../Partials/CreateForm";
import { ErasmusIncomingType } from "utils/constants";
import { getStyle } from "customStyles/utils";
import { settings } from "app";
import { convertData } from "../helpers";
import BackButtonToolbar from "features/BackButtonToolbar";
const CreateIncomingRegularStudent = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const style = getStyle(settings.tenant);

  const [loadingSend, setLoadingSend] = useState(false);

  const [isDisable, setIsDisable] = useState(false);
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSend = data => {
    setLoadingSend(true);
    return {
      ...convertData(data),
    };
  };
  return (
    <div style={loadingSend ? { opacity: 0.5 } : { opacity: 1 }}>
      {loadingSend && (
        <div style={style.loadingStyle.container}>
          <CircularProgress size={200} />
          <div style={style.loadingStyle.text}>Saving...</div>
        </div>
      )}

      <Create
        title="Създаване на пристигащ студент за обучение и BIP"
        transform={handleSend}
        actions={
          <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
            <BackButtonToolbar />
          </TopToolbar>
        }
        mutationOptions={{
          meta: { useFormData: true },
          onSuccess: data => {
            setLoadingSend(false);
            redirect(`list`, `erasmus/incoming/students/regular`);
          },
          onError: error => {
            console.error(error);

            setLoadingSend(false);
            notify(error.message, { type: "error" });
          },
        }}
      >
        <SimpleForm>
          <CreateForm
            isDisable={isDisable}
            setIsDisable={setIsDisable}
            isMobile={isMobile}
            type={ErasmusIncomingType.Regular}
          />
        </SimpleForm>
      </Create>
    </div>
  );
};
export default CreateIncomingRegularStudent;
